import { SvgIcon, SvgIconProps } from '@mui/material'

const PinIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.3328 4.66504V7.99837C11.3328 8.74504 11.5795 9.43837 11.9995 9.99837H7.99951C8.43284 9.42504 8.66617 8.73171 8.66617 7.99837V4.66504H11.3328ZM13.3328 3.33171H6.66617C6.29951 3.33171 5.99951 3.63171 5.99951 3.99837C5.99951 4.36504 6.29951 4.66504 6.66617 4.66504H7.33284V7.99837C7.33284 9.10504 6.43951 9.99837 5.33284 9.99837V11.3317H9.31284V15.9984L9.97951 16.665L10.6462 15.9984V11.3317H14.6662V9.99837C13.5595 9.99837 12.6662 9.10504 12.6662 7.99837V4.66504H13.3328C13.6995 4.66504 13.9995 4.36504 13.9995 3.99837C13.9995 3.63171 13.6995 3.33171 13.3328 3.33171Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default PinIcon
